export { API_URL as baseURL } from "./constants";

export const APP_URLS = {
  getBanner: () => `/index.php?action=banner-list`,
  getBannerOffer: () => `/index.php?action=find-offer-banner-list`,
  getCategoryList: () => `/index.php?action=category-list`,
  getProductsTypes: () => `/index.php?action=list-product-view`,
  registerUser: () => `/index.php?action=register`,
  getListProductVariantsMax: () => `/index.php?action=list-product-view-max`,
  getProductVariants: () => `/index.php?action=list-product-variants`,
  getProductsList: (params) => `/index.php?action=list-products&${params}`,
  getSingleProductsList: (slug) =>
    `/index.php?action=single-product&slug=${slug}`,
  validateOtp: () => `/index.php?action=verify-otp`,
  generateOtp: () => `/index.php?action=send-otp`,
  refreshToken: () => `/index.php?action=refresh-token`,
  addRegister: () => `/index.php?action=register`,
  logoutUser: () => `/index.php?action=logout`,
  addressUpdate: () => `/index.php?action=address-update`,
  getAddressList: () => `/index.php?action=address-list`,
  addressCreate: () => `/index.php?action=address-create`,
  userUpdate: (userId) => `/index.php?action=update&id=${userId}`,
  userUploadAvatar: () => `/index.php?action=upload-avatar`,
  addressDelete: () => `/index.php?action=address-delete`,
  setDefaultAddress: (userId, addressId) =>
    `/index.php?action=set-default-address&userId=${userId}&addressId=${addressId}`,
  addressDeliverDefault: (userId) =>
    `/index.php?action=address-get-default&userId=${userId}`,
   getCheckout: (userId) =>
    `/index.php?action=get-checkout&userId=${userId}`,
  getSubscriberLogin: () => `/login`,
  getSubscriberEmail: (email) => `/getSubscriberEmail?email=${email}`,
  getUser: (id) => `/consumer/get/${id}`,
  updateRegister: (id) => `/consumer/update/${id}`,
  createOrder: () => `/index.php?action=create-order`,
  getOrderDetails: (orderId, userId) => `/index.php?action=get-order-details&orderId=${orderId}&userId=${userId}`,
  getConsumerBookingDetails: (id) => `/booking/findByConsumer/${id}`,
  addReview: () => `/reviews/create`,
  getPaymentMethods: () => `/index.php?action=get-payment-methods`,
  generateUPIQR: () => `/index.php?action=generate-upi-qr`,
  processUPIIntent: () => `/index.php?action=process-upi-intent`,
  verifyPayment: () => `/index.php?action=verify-payment`,
  retryPayment: () => `/index.php?action=retry-payment`,
  processCardPayment: () => `/index.php?action=process-card-payment`,
  processCOD: () => `/index.php?action=process-cod-payment`,
  applyGiftCard: () => `/index.php?action=apply-gift-card`,
  getUserOrders: (userId) => `/index.php?action=get-user-orders&userId=${userId}`,
  loadSavedCards: (userId) => `/index.php?action=load-saved-cards&userId=${userId}`,

};
